(() => {
  if (Number(window.Shopify?.theme?.id) !== 210301813004) return;
  if(window.Shopify?.theme?.role==='main') return;
  const originalFetch = window.fetch.bind(window);
  function allowedDiscoveryCart(url,options) {
    if(url.origin!==location.origin||!['/cart/add.js','/cart/change.js'].includes(url.pathname)||options.method?.toUpperCase()!=='POST')return false;
    const config=document.querySelector('[data-delivery-picker] [data-discovery-checkout]');
    if(!config)return false;
    try {
      const products=JSON.parse(config.textContent).products;
      const specs={relay:[16581257593100,739239723276],home:[16581257691404,739239756044]};
      if(!Object.entries(specs).every(([mode,[id,plan]])=>products[mode]?.id===id&&products[mode].planId===plan))return false;
      const payload=JSON.parse(options.body);
      if(url.pathname==='/cart/change.js')return payload.quantity===0&&typeof payload.id==='string'&&Object.values(products).some(p=>p.variants.some(v=>payload.id.startsWith(`${v.id}:`)));
      const item=payload.items?.[0];
      return payload.items?.length===1&&Number.isSafeInteger(item.quantity)&&item.quantity>0&&item.properties?._anom_funnel_key==='decouverte-delivery-pilot'&&Object.values(products).some(p=>p.planId===item.selling_plan&&p.variants.some(v=>v.id===item.id&&v.available&&v.plans.some(a=>a.id===item.selling_plan&&a.price===Math.round(v.price*.5))));
    } catch {return false;}
  }
  function allowedPilotCart(url,options) {
    if(url.origin!==location.origin||!['/cart/add.js','/cart/change.js'].includes(url.pathname)||options.method?.toUpperCase()!=='POST') return false;
    const root=document.querySelector('[data-preview-funnel][data-offer="quotidien"]');
    const config=root?.querySelector('[data-quotidien-checkout]');
    if(!config) return false;
    try {
      const data=JSON.parse(config.textContent);
      const payload=JSON.parse(options.body);
      if(url.pathname==='/cart/change.js') return data.productId===16580881842444&&payload.quantity===0&&typeof payload.id==='string'&&data.variants.some(variant=>payload.id.startsWith(`${variant.id}:`));
      const item=payload.items?.[0];
      return data.productId===16580881842444&&data.planIds.relay===739234939148&&payload.items.length===1&&Number.isSafeInteger(item.quantity)&&item.quantity>0&&Object.values(data.planIds).filter(Boolean).includes(item.selling_plan)&&data.variants.some(variant=>variant.id===item.id&&variant.available&&variant.plans.some(plan=>plan.id===item.selling_plan&&plan.price===variant.price));
    } catch {return false;}
  }
  window.fetch = (input, options = {}) => {
    const url = new URL(typeof input === 'string' ? input : input.url, location.href);
    const method = (options.method || input.method || 'GET').toUpperCase();
    if (method !== 'GET' && /\/cart(?:\/|\.)|\/checkout|\/contact(?:\?|$)/.test(url.pathname) && !allowedPilotCart(url,options) && !allowedDiscoveryCart(url,options)) {
      return Promise.reject(new Error('Unpublished ANOM preview: business writes disabled.'));
    }
    return originalFetch(input, options);
  };
  const notice = document.createElement('div');
  notice.className = 'aq-preview-notice';
  notice.textContent = document.querySelector('[data-quotidien-checkout]')?'Pilote Quotidien · Commande réelle possible':document.querySelector('[data-discovery-checkout]')?'Pilote Découverte · Commande réelle possible':'Brouillon de travail · Aucun achat ni inscription';
  notice.setAttribute('role', 'status');
  document.body.append(notice);
  function blocked(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    notice.textContent = 'Brouillon : les achats et inscriptions sont désactivés.';
  }
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-aq-config], [method="dialog"]')) return;
    blocked(event);
  }, true);
  document.addEventListener('click', event => {
    const action = event.target.closest('a, button, input[type="submit"]');
    if (!action) return;
    const href = action.getAttribute('href') || '';
    if (action.matches('.js-funnel-submit, [data-dock-submit]') && action.closest('[data-anom-funnel]') && !action.closest('[data-preview-funnel]') && !action.closest('[data-delivery-picker]')?.querySelector('[data-discovery-checkout]')) {
      blocked(event);
      return;
    }
    if (/\/checkout|\/cart\/add|^\/discount\//.test(href) || action.matches('[name="add"], [name="checkout"], .shopify-payment-button__button')) { blocked(event); return; }
    if (href.includes('/products/abonnement-cafe') || href.includes('view=club-configurateur')) {
      event.preventDefault();
      window.location.assign('/pages/abonnement-cafe-de-specialite?view=decouverte&preview_theme_id=210301813004');
      return;
    }
    if (action.tagName === 'A' && href && !href.startsWith('#') && !href.startsWith('mailto:')) {
      const url = new URL(href, location.href);
      if (url.origin === location.origin && !url.pathname.startsWith('/account')) {
        url.searchParams.set('preview_theme_id', '210301813004');
        action.href = url.href;
      }
    }
  }, true);
})();
